module.exports = __webpack_public_path__ + "static/media/man_engineer.4a21d3d7.jpg";